import get from "lodash/get";
import * as ERRORES from "../../config/constants/step-constants";

const FloodlightActivities = {
  enable() {},
  init() {
    window.gtag("js", new Date());
    window.gtag("config", "DC-10031883");
  },
  wait() {
    return !!window.gtag;
  },
  landing() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/prest0/prest0+standard"
    });
  },
  paso1() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/prest0/prest00+standard"
    });
  },
  paso2() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/prest0/prest000+standard"
    });
  },
  paso3() {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      send_to: "DC-10031883/prest0/prest001+standard"
    });
  },
  paso4(context) {
    window.gtag("event", "conversion", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      u7: context.state.responseOferta.respuesta.oferta.montoMaximo,
      send_to: "DC-10031883/prest0/prest002+standard"
    });
  },
  gracias(context) {
    window.gtag("event", "purchase", {
      allow_custom_scripts: true,
      u3: get(window, "location.href", ""), //URL
      u7: context.state.responseOferta.respuesta.oferta.montoMaximo,
      send_to: "DC-10031883/prest000/prest0+transactions"
    });
  },
  mensaje(context) {
    switch (context.mutation.payload.params.mje) {
      case ERRORES.ERROR_TECNICO:
        window.gtag("event", "conversion", {
          allow_custom_scripts: true,
          u3: get(window, "location.href", ""), //URL
          send_to: "DC-10031883/prest0/prest004+standard"
        });
        break;
      case ERRORES.INDIVIDUO_NEGATIVO:
        window.gtag("event", "conversion", {
          allow_custom_scripts: true,
          u3: get(window, "location.href", ""), //URL
          send_to: "DC-10031883/prest0/prest005+standard"
        });
        break;
      default:
        window.gtag("event", "conversion", {
          allow_custom_scripts: true,
          u3: get(window, "location.href", ""), //URL
          send_to: "DC-10031883/prest0/prest003+standard"
        });
        break;
    }
  }
};

export default FloodlightActivities;
